import React from "react";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";

export interface MachineServiceCardProps {
	readonly title: React.ReactNode;
	readonly children: React.ReactNode;
}

export const MachineServiceCard: React.FC<MachineServiceCardProps> = ({ title, children }) => (
	<Card variant="outlined">
		<CardHeader title={<Typography variant="h2">{title}</Typography>} />
		<CardContent>{children}</CardContent>
	</Card>
);
